// todo: Use PaperModal as base component
import { Box, Modal, Paper, Typography, Button } from '@mui/material';
import { useStyles } from '../styles/ConfirmModal.styles';

import type { Dispatch, ReactNode, SetStateAction } from 'react';

type ConfirmModalProps = {
    disabled?: boolean;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    title: string;
    onConfirm: () => void;
    onCancel?: () => void;
    children?: ReactNode;
};

export const ConfirmModal = ({
    open,
    title,
    onConfirm,
    onCancel,
    setOpen,
    disabled = false,
    children,
}: ConfirmModalProps) => {
    const styles = useStyles();

    const handleConfirm = () => {
        setOpen(false);
        onConfirm();
    };

    const handleCancel = () => {
        setOpen(false);
        onCancel?.();
    };

    return (
        <Modal open={open}>
            <Paper className={styles.container}>
                <Box className={styles.header}>
                    <Typography color='white' fontWeight='bold'>
                        {title}
                    </Typography>
                </Box>

                <Box className={styles.content}>{open && children}</Box>

                <Box className={styles.buttonContainer}>
                    <Button className={styles.cancelButton} variant='contained' size='small' onClick={handleCancel}>
                        Cancel
                    </Button>

                    <Button variant='contained' color='error' size='small' onClick={handleConfirm} disabled={disabled}>
                        Confirm
                    </Button>
                </Box>
            </Paper>
        </Modal>
    );
};
